import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScRequirements = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & .title {
    text-align: start;
    ${typography.body1bold};
  }

  & .points-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-start;
    padding: 12px;
    border-radius: 12px;
    width: fit-content;
    background: radial-gradient(
      161.21% 160.39% at 5.71% -44.13%,
      #363636 0%,
      rgba(26, 26, 26, 0.27) 100%
    );

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      padding: 1px;
      border-radius: inherit;
      background: linear-gradient(
        135deg,
        #ffffff 0%,
        #ffffff41 33%,
        #ffffffbb 66%,
        #ffffff12 100%
      );
      opacity: 0.3;
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }

    & .step {
      display: flex;
      align-items: center;
      padding: 6px 8px 6px 0;
      gap: 4px;
      & .text {
        ${typography.caption1regular};
        text-align: left;
        font-weight: 700;
      }
    }
  }

  @media (${device.mobile}) {
    & .points-wrapper {
      width: 100%;
    }
  }
`;
